var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CallInPopup',{ref:"callInPopupRef",attrs:{"client":_vm.callInClient,"client_id":_vm.callInClient.client_id}})
}
var staticRenderFns = []

export { render, staticRenderFns }